module.exports = __webpack_public_path__ + "static/img/banner-sample.b997b3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-sample.jpg
// module id = Oc4j
// module chunks = 1